






import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import ButtonMixin from "@/mixins/ButtonMixin";
import i18n from "@/i18n";

@Component
export default class ForwardButton extends mixins(ButtonMixin) {
  public name = "ForwardButton";

  @Prop({ default: () => i18n.t("general.button_forward") })
  public tooltipLabel!: string;
}
